export default __webpack_public_path__ + "static/media/gallery-14-4.cde14679.webp";